// extracted by mini-css-extract-plugin
export default {"mainContentPage":"mainContentPage_MhGg"};